import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { Download } from 'lucide-react';
import toast from 'react-hot-toast';

// Varsayilan Tahsilat mapping'i (geriye uyumluluk icin korunur)
const defaultCollectionMapper = (row) => ({
    'Tarih': new Date(row.createdAt).toLocaleDateString('tr-TR'),
    'Satıcı': row.seller,
    'Alıcı': row.buyer,
    'Kurum / Banka': row.institution,
    'Asıl Tutar': row.amount,
    'Kalan Tutar (Kısmi)': row.remainingAmount !== null ? row.remainingAmount : row.amount,
    'Döviz': row.currency,
    'Tahsil Durumu': row.isCollected ? 'Tahsil Edildi' : 'BEKLİYOR',
    'Muhasebe Durumu': row.isAccounted ? 'İşlendi' : 'İşlenmedi',
    'Transfer Referans No': row.transferNo || '-',
    'Notlar / Açıklama': row.notes || '-'
});

// Excel'in kullanıcı metnini formül olarak çalıştırmasını engelle.
const sanitizeExportRow = (row) => Object.fromEntries(
    Object.entries(row).map(([key, value]) => [
        key,
        typeof value === 'string' && /^[=+\-@]/.test(value.trimStart()) ? `'${value}` : value,
    ])
);

const ExportExcelButton = ({
    data,
    filename = "Tahsilatlar_Raporu.xlsx",
    mapper = defaultCollectionMapper,
    sheetName = "Tahsilatlar",
    label = "EXCEL İNDİR",
    loadData,
}) => {
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = async () => {
        if (isExporting) return;

        setIsExporting(true);
        try {
            const sourceData = loadData ? await loadData() : data;
            if (!sourceData || sourceData.length === 0) {
                toast.error("Dışa aktarılacak veri bulunamadı.");
                return;
            }

            // Excel'e aktarılacak sadece gerekli ve temizlenmiş verileri maple
            const exportData = sourceData.map((row) => sanitizeExportRow(mapper(row)));

            // Yeni Bir Çalışma Kitabı ve Sayfa (Worksheet) Oluştur
            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

            // Dosyayı Kullanıcıya İndirt
            XLSX.writeFile(workbook, filename);
        } catch (error) {
            console.error('Excel dışa aktarma başarısız', error);
            toast.error('Excel dosyası hazırlanamadı.');
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <button
            onClick={handleExport}
            disabled={isExporting}
            className="w-full md:w-auto flex items-center justify-center gap-2 bg-green-600/20 hover:bg-green-600 border border-green-500/50 text-green-400 hover:text-white px-5 py-2.5 rounded-xl font-bold tracking-wide transition-all shadow-lg hover:scale-105 active:scale-95 disabled:opacity-60 disabled:cursor-wait disabled:hover:scale-100"
            title="Aktif filtrelere uyan tüm kayıtları Excel'e aktar"
        >
            <Download size={18} />
            <span className="text-sm">{isExporting ? 'HAZIRLANIYOR...' : label}</span>
        </button>
    );
};

export default ExportExcelButton;
